<template>
  <v-card class="d-flex align-center justify-center pa-5 tournament-not-started" outlined
    style="background-color: rgba(0,0,0,0); min-height: 70vh;">
    <v-container v-if="adminUser" fluid>
      <div class="d-flex justify-center">
        <v-img v-if="!inviteOnly" class="mb-5" position="center center"
          src="https://hub.swiset.com/wp-content/uploads/2021/01/Tournaments-Ranking-Swiset.png" max-width="91px" contain />
        <svg v-else width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40.715" cy="40.715" r="38.715" fill="#FDE4D3" stroke="white" stroke-width="4" />
          <g clip-path="url(#clip0_1793_7776)">
            <path
              d="M40.7152 19.2976C42.0729 19.2976 43.3254 20.0147 44.0138 21.1907L64.666 56.3759C65.364 57.5615 65.364 59.0244 64.6851 60.21C64.0063 61.3956 62.7346 62.1318 61.3674 62.1318H20.063C18.6958 62.1318 17.4241 61.3956 16.7453 60.21C16.0664 59.0244 16.076 57.552 16.7644 56.3759L37.4166 21.1907C38.105 20.0147 39.3575 19.2976 40.7152 19.2976ZM40.7152 31.5359C39.4436 31.5359 38.4205 32.559 38.4205 33.8306V44.5392C38.4205 45.8108 39.4436 46.8339 40.7152 46.8339C41.9868 46.8339 43.0099 45.8108 43.0099 44.5392V33.8306C43.0099 32.559 41.9868 31.5359 40.7152 31.5359ZM43.7748 52.953C43.7748 52.1416 43.4524 51.3633 42.8787 50.7896C42.3049 50.2158 41.5267 49.8934 40.7152 49.8934C39.9038 49.8934 39.1255 50.2158 38.5518 50.7896C37.978 51.3633 37.6556 52.1416 37.6556 52.953C37.6556 53.7645 37.978 54.5427 38.5518 55.1165C39.1255 55.6903 39.9038 56.0126 40.7152 56.0126C41.5267 56.0126 42.3049 55.6903 42.8787 55.1165C43.4524 54.5427 43.7748 53.7645 43.7748 52.953Z"
              fill="#FF8933" />
          </g>
          <defs>
            <clipPath id="clip0_1793_7776">
              <rect width="48.9533" height="48.9533" fill="white" transform="translate(16.2383 16.2378)" />
            </clipPath>
          </defs>
        </svg>

      </div>
      <h1 class="text-center">{{ $t('planning') }}</h1>
      <h3 class="text-center">{{ $t('description_TournamentNotStarted', { value: $store.state.tournament.participants.length }) }}</h3>
      <v-row class="mt-7" align="center" justify="center">
        <v-btn class="button-participants" @click="goToParticipants">
          {{ $t('btnGo') }} <v-icon class="ml-2" color="white" small>fa-users</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container v-else fluid>
      <v-overlay :dark="false" absolute v-model="canIRegister">
        <TournamentRegisterCollapsed />
      </v-overlay>
      <div class="d-flex justify-center">
        <v-img v-if="!inviteOnly" class="mb-5" position="center center"
          src="https://hub.swiset.com/wp-content/uploads/2021/01/Tournaments-Ranking-Swiset.png" max-width="91px" contain />
        <svg v-else width="120" height="120" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40.715" cy="40.715" r="38.715" fill="#FDE4D3" stroke="#f9f9f9" stroke-width="4" />
          <g clip-path="url(#clip0_1793_7776)">
            <path
              d="M40.7152 19.2976C42.0729 19.2976 43.3254 20.0147 44.0138 21.1907L64.666 56.3759C65.364 57.5615 65.364 59.0244 64.6851 60.21C64.0063 61.3956 62.7346 62.1318 61.3674 62.1318H20.063C18.6958 62.1318 17.4241 61.3956 16.7453 60.21C16.0664 59.0244 16.076 57.552 16.7644 56.3759L37.4166 21.1907C38.105 20.0147 39.3575 19.2976 40.7152 19.2976ZM40.7152 31.5359C39.4436 31.5359 38.4205 32.559 38.4205 33.8306V44.5392C38.4205 45.8108 39.4436 46.8339 40.7152 46.8339C41.9868 46.8339 43.0099 45.8108 43.0099 44.5392V33.8306C43.0099 32.559 41.9868 31.5359 40.7152 31.5359ZM43.7748 52.953C43.7748 52.1416 43.4524 51.3633 42.8787 50.7896C42.3049 50.2158 41.5267 49.8934 40.7152 49.8934C39.9038 49.8934 39.1255 50.2158 38.5518 50.7896C37.978 51.3633 37.6556 52.1416 37.6556 52.953C37.6556 53.7645 37.978 54.5427 38.5518 55.1165C39.1255 55.6903 39.9038 56.0126 40.7152 56.0126C41.5267 56.0126 42.3049 55.6903 42.8787 55.1165C43.4524 54.5427 43.7748 53.7645 43.7748 52.953Z"
              fill="#FF8933" />
          </g>
          <defs>
            <clipPath id="clip0_1793_7776">
              <rect width="48.9533" height="48.9533" fill="white" transform="translate(16.2383 16.2378)" />
            </clipPath>
          </defs>
        </svg>

      </div>
      <div v-if="!inviteOnly">
        <h1 class="text-center">{{ $t('waiting') }}...</h1>
        <h3 class="text-center">{{ $t('beingCreated') }}</h3>
      </div>
      <div v-else>
        <h1 class="text-center">{{ $t('inviteOnly.title') }}</h1>
        <h3 class="text-center">{{ $t('inviteOnly.text') }}</h3>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import TournamentRegisterCollapsed from "@/views/Tournament/components/TournamentRegisterCollapsed";
export default {
  name: "TournamentNotStarted",
  components: { TournamentRegisterCollapsed },
  props: {
    inviteOnly: Boolean,
    iAmParticipant: Boolean,
    currentParticipants: Number,
  },
  data() {
    return {
      adminUser: false,
      canIRegister: false,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    '$store.state.tournament': function () {
      this.init();
      this.verifyCanIRegister();
    },
    iAmParticipant() {
      this.verifyCanIRegister();
    }
  },
  methods: {
    init() {
      this.verifyAdminUser();
      this.verifyCanIRegister();
    },
    verifyCanIRegister() {
      if(this.inviteOnly){
        this.canIRegister = false;
        
      } else{ 
      let visibility = this.$store.state.tournament.tournamentSettings.tournamentVisibility;
      let isClubMember = this.$store.state.clubMember !== null && this.$store.state.tournament.tournamentOrganizerId === this.$store.state.clubMember.club.id;
      this.canIRegister = !this.iAmParticipant && (visibility === 'PUBLIC' || (visibility === 'PRIVATE' && isClubMember));
      }
    },
    verifyAdminUser() {
      if (this.$store.state.tournament !== null && this.$store.state.clubMember !== null)
        this.adminUser = this.$store.state.tournament.tournamentOrganizerId === this.$store.state.clubMember.club.id &&
          (this.$store.state.clubMember.rol === 'FOUNDER') || (this.$store.state.clubMember.rol === 'ADMIN');
    },
    goToParticipants() {
      this.$emit('goToParticipants');
    },
  }
}
</script>



<style lang="scss">
.tournament-not-started {
  .ban-icon {
    font-size: 82px;
    margin-bottom: 10px;
    color: #C42A14;
  }

  @media (max-width: 1290px) {
    h1 {
      font-size: 18px;
      margin-bottom: 20px;
    }

    h3 {
      font-size: 14px;
    }
  }

  .button-participants {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }
}
</style>
